export const formatNumberWithCommas = (num) => {
    if (typeof num !== "number") return num;

    num = num.toFixed(1);
    num = parseFloat(num);

    return num.toLocaleString("en-US");
};
